{
  "block_page_editor": {
    "add_comment": "Ajouter un commentaire",
    "untitled_placeholder": "Sans titre"
  },
  "block_page_list_menu_options": {
    "page_options_aria_label": "options de page",
    "long_menu_aria_controls": "menu-long",
    "delete_page_aria_label": "supprimer la page"
  },
  "block_page_list": {
    "add_page_aria_label": "ajouter une page",
    "page_names_aria_label": "noms des pages",
    "untitled_page": "Page sans titre",
    "add_page": "Ajouter une page"
  },
  "block_page_ui": {
    "loading_page_aria_label": "chargement de la page",
    "error_prefix": "Erreur : "
  },
  "task_with_section_block": {
    "add_task": "Ajouter une tâche",
    "task_name_empty_error": "Le nom de la tâche ne peut pas être vide",
    "add_task_error": "Une erreur inattendue s'est produite lors de l'ajout de la tâche.",
    "section_placeholder": "Tapez la section de tâche ou sélectionnez une section existante",
    "create_section_error": "Une erreur inattendue s'est produite lors de la création de la section.",
    "create_new_task_aria": "créer une nouvelle tâche",
    "add_task_to_section_aria": "Ajouter une tâche à la section",
    "toggle_dropdown_aria": "Basculer le menu déroulant de section",
    "section_title_aria": "titre de section"
  },
  "block_note_emoji_picker": {
    "add_emoji": "Ajouter un emoji"
  },
  "block_provider_editor": {
    "syncing": "Synchronisation..."
  },
  "remove_page": {
    "confirm_delete_title": "Êtes-vous sûr de vouloir supprimer cette page ?",
    "confirm_delete_content": "Cliquez sur le bouton confirmer pour supprimer la page."
  },
  "images_block": {
    "insert_image_url": "Insérer l'URL de l'image",
    "image_url": "URL de l'image",
    "image_url_placeholder": "Entrez l'URL de l'image",
    "image_url_required": "L'URL de l'image est requise.",
    "image_caption": "Légende de l'image",
    "image_caption_placeholder": "Entrez la légende de l'image",
    "insert_image": "Insérer l'image"
  },
  "contact_card_block": {
    "contact_required": "Le contact est requis",
    "contact": "Contact",
    "add_contact_card": "Ajouter une carte de contact",
    "add_contact_card_placeholder": "Ajouter une carte de contact par nom ou courriel"
  },
  "checklist_items_block": {
    "title": "Élément de liste de contrôle",
    "subtext": "Insérer une ligne d'élément de liste de contrôle"
  },
  "checklists_block": {
    "title": "Insérer un bloc de listes de contrôle",
    "subtext": "Insérer un bloc de liste de contrôle",
    "checklist_title_placeholder": "Entrez le titre de la liste de contrôle",
    "item_label_placeholder": "Entrez l'étiquette"
  },
  "linkable_tab_block": {
    "title": "Lien vers l'onglet",
    "subtext": "Insérer un lien vers un onglet d'espace de travail",
    "select_tab_prompt": "Sélectionnez l'onglet à lier"
  },
  "company_card_block": {
    "title": "Carte d'entreprise",
    "subtext": "Insérer une carte d'entreprise",
    "company_required": "L'entreprise est requise",
    "company_label": "Entreprise",
    "add_company_card_label": "Ajouter une carte d'entreprise",
    "add_company_card_placeholder": "Ajouter une carte d'entreprise"
  },
  "documents_upload_block": {
    "modal_header": "Ajouter un document",
    "document_name_label": "Nom du document",
    "document_url_label": "URL du document",
    "or": "ou",
    "drag_drop_text": "Glissez un seul document ici ou cliquez pour télécharger",
    "url_required_error": "Veuillez saisir une URL ou télécharger le document",
    "file_size_error": "Taille de fichier maximale : 50 Mo, taille actuelle : {{size}} Mo",
    "unsupported_file_error": "Type de fichier non pris en charge : {{type}}"
  },
  "campaign_analysis_block": {
    "campaign_required": "La campagne est requise",
    "campaign_label": "Campagne",
    "select_campaign_placeholder": "Sélectionner une campagne",
    "no_campaigns_message": "Veuillez créer une campagne dans cet espace de travail avant de continuer.",
    "loading_campaign": "Chargement de la campagne"
  },
  "task_list_block": {
    "table_headers": {
      "title": "Titre",
      "delegated_to": "Délégué à",
      "due_date": "Date d'échéance",
      "status": "Statut"
    },
    "no_tasks_found": "Aucune tâche trouvée."
  },
  "youtube_block": {
    "modal_header": "Insérer une vidéo YouTube",
    "url_label": "URL YouTube",
    "url_placeholder": "Saisir l'URL YouTube",
    "invalid_url_error": "Veuillez saisir une URL YouTube valide.",
    "insert_button": "Insérer la vidéo",
    "video_player_title": "Lecteur vidéo YouTube Nexl"
  },
  "rollup_field_block": {
    "title": "Champs de cumul",
    "open_modal_aria_label": "Ouvrir la modale des champs de cumul",
    "insert": {
      "title": "Champ de cumul",
      "subtext": "Afficher les résumés de cumul des valeurs des listes associées."
    },
    "table": {
      "columns": {
        "rollup_name": "Nom du cumul",
        "source": "Source",
        "value": "Valeur"
      },
      "opportunities": "Opportunités"
    }
  }
}
